import React from 'react';
import PropTypes from 'prop-types';
import Widget from 'components/Widget/index';
import PlaceholderSpinner from 'components/kea/placeholders/PlaceholderSpinner';
import styles from './WidgetWithChart.module.scss';

const WidgetWithChart = ({
  title,
  mainNumber,
  description,
  chart,
  isFetching,
  tone,
  selected,
  onSelect,
}) => {
  const isInteractive = Boolean(onSelect);
  const ContentTag = isInteractive ? 'button' : 'div';

  return (
    <Widget styleName={`jr-card-full noMargin ${styles.card} ${styles[tone] || ''} ${isInteractive ? styles.interactiveCard : ''} ${isInteractive && selected ? styles.selected : ''}`}>
    {
      isFetching
        ? <div className={styles.loading}><PlaceholderSpinner height={144} /></div>
        : (
          <ContentTag
            className={`${styles.content} ${isInteractive ? styles.interactive : ''}`}
            role={isInteractive ? undefined : 'group'}
            aria-label={typeof title === 'string' && typeof description === 'string'
              ? `${title}: ${mainNumber}. ${description}`
              : undefined}
            type={isInteractive ? 'button' : undefined}
            aria-pressed={isInteractive ? selected : undefined}
            onClick={onSelect}
          >
            <p className={styles.eyebrow}>{title}</p>
            <div className={styles.body}>
              <div className={styles.metric}>
                <p className={styles.value}>{mainNumber}</p>
                <p className={styles.description}>{description}</p>
              </div>
              <div className={styles.chart} aria-hidden="true">
                {chart}
              </div>
            </div>
          </ContentTag>
        )
      }
    </Widget>
  );
};

WidgetWithChart.propTypes = {
  title: PropTypes.node.isRequired,
  mainNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  description: PropTypes.node.isRequired,
  chart: PropTypes.node,
  isFetching: PropTypes.bool,
  tone: PropTypes.oneOf(['searches', 'clickRate', 'zeroResults', 'clickEvents', 'lostOpportunities']),
  selected: PropTypes.bool,
  onSelect: PropTypes.func,
};

WidgetWithChart.defaultProps = {
  chart: null,
  isFetching: false,
  tone: 'searches',
  selected: false,
  onSelect: null,
};

export default WidgetWithChart;
